import dynamic from 'next/dynamic'
import { SectionSocialMediaEmbedProps } from '@portfolio/models'
import { Embed, SectionWrapper } from '@portfolio/components'
import { screenSizes, styled } from '@portfolio/styles'
import { useInView } from 'react-intersection-observer'

const Masonry = dynamic(
  () => import('react-responsive-masonry').then((mod) => mod.default),
  { ssr: false },
)
const ResponsiveMasonry = dynamic(
  () => import('react-responsive-masonry').then((mod) => mod.ResponsiveMasonry),
  { ssr: false },
)

const StyledSectionWrapper = styled(SectionWrapper, {
  maxWidth: '$richTextWidth',
  containerSpace: 'medium',
})

const Headline = styled('h3', {
  marginBottom: '.75em',
  marginTop: '1.5em',
  projectFont: 'heading07',
})

const EmbedWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  gap: '$8',
  width: '100%',
  variants: {
    width: {
      full: {
        width: '100%',
      },
      medium: {
        width: '100%',
        '@md': {
          width: '75%',
        },
      },
      small: {
        width: '100%',
        '@md': {
          width: '50%',
        },
      },
    },
    centered: {
      true: {
        margin: '0 auto',
      },
    },
  },
})

export const SectionSocialMediaEmbed = ({
  headline,
  embeds,
}: SectionSocialMediaEmbedProps) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '500px 0px',
  })

  if (!embeds || embeds.length === 0) {
    return null
  }

  return (
    <StyledSectionWrapper ref={ref} type="RICH_TEXT_MD">
      {headline && <Headline>{headline}</Headline>}
      {inView && (
        <>
          {embeds && embeds.length === 1 ? (
            <EmbedWrapper width={embeds[0].width} centered>
              <Embed {...embeds[0]} />
            </EmbedWrapper>
          ) : (
            <ResponsiveMasonry
              columnsCountBreakPoints={{
                [screenSizes.sm]: 1,
                [screenSizes.md]: 2,
              }}
            >
              <Masonry gutter="12px">
                {embeds?.map((embed, index) => (
                  <EmbedWrapper key={index}>
                    <Embed {...embed} />
                  </EmbedWrapper>
                ))}
              </Masonry>
            </ResponsiveMasonry>
          )}
        </>
      )}
    </StyledSectionWrapper>
  )
}
